<template>
  <div class="list-container">
    <div class="filter-container">
        <div class="filter-box">
          <span class="label">业务编号</span>
          <el-input
            v-model="listQuery.businessNo"
            style="width: 200px"
            :size="t('table.btnSize')"
            class="filter-item"
            clearable
            @keyup.enter="handleFilter"
          />
        </div>
        <div class="filter-box">
          <span class="label">业务名称</span>
          <el-input
              v-model="listQuery.businessName"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
        </div>
        <div class="filter-box">
          <span class="label">业务品牌</span>
          <el-input
              v-model="listQuery.businessBrand"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
        </div>
        <div class="filter-box">
          <span class="label">业务型号</span>
          <el-input
              v-model="listQuery.businessModel"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
        </div>
        <div class="filter-box">
          <span class="label">序列号</span>
          <el-input
              v-model="listQuery.businessSerial"
              style="width: 200px"
              :size="t('table.btnSize')"
              class="filter-item"
              clearable
              @keyup.enter="handleFilter"
            />
        </div>

        <div class="filter-box">
          <span class="label">材料编号</span>
          <el-input
            v-model="listQuery.materialNo"
            style="width: 200px"
            :size="t('table.btnSize')"
            class="filter-item"
            clearable
            @keyup.enter="handleFilter"
          />
        </div>
        <div class="filter-box">
          <span class="label">材料品牌</span>
          <el-input
            v-model="listQuery.materialBrand"
            style="width: 200px"
            :size="t('table.btnSize')"
            class="filter-item"
            clearable
            @keyup.enter="handleFilter"
          />
        </div>
        <div class="filter-box">
          <span class="label">材料名称</span>
          <el-input
            v-model="listQuery.materialName"
            style="width: 200px"
            :size="t('table.btnSize')"
            class="filter-item"
            clearable
            @keyup.enter="handleFilter"
          />
        </div>
        <div class="filter-box">
          <span class="label">材料型号</span>
          <el-input
            v-model="listQuery.materialModel"
            style="width: 200px"
            :size="t('table.btnSize')"
            class="filter-item"
            clearable
            @keyup.enter="handleFilter"
          />
        </div>
        <div class="filter-box">
          <span class="label">材料代码</span>
          <el-input
            v-model="listQuery.materialCode"
            style="width: 200px"
            :size="t('table.btnSize')"
            class="filter-item"
            clearable
            @keyup.enter="handleFilter"
          />
        </div>

        <div class="filter-box">
          <span class="label">申请人</span>
          <el-select :filterable="true" v-model="listQuery.createUser" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @focus="handleCreateUserFocus" @change="handleFilter">
            <el-option
              v-for="item in createUserOption"
              :key="item.id"
              :label="item.mark"
              :value="item.id"
            />
          </el-select>
        </div>

        <div class="filter-box">
          <span class="label">开始日期</span>
          <el-date-picker
            v-model="listQuery.startTime"
            type="date"
            placeholder=" "
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
            @change="handleFilter"
            :size="t('table.btnSize')"
          >
          </el-date-picker>
        </div>
        <div class="filter-box">
          <span class="label">结束日期</span>
          <el-date-picker
            v-model="listQuery.endTime"
            type="date"
            placeholder=" "
            format="YYYY-MM-DD"
            value-format="YYYY-MM-DD"
            @change="handleFilter"
            :size="t('table.btnSize')"
          >
          </el-date-picker>
        </div>
        <div class="filter-box">
          <span class="label">状态</span>
          <el-select :filterable="true" v-model="listQuery.status" class="filter-item" placeholder="" clearable :size="t('table.btnSize')" @change="handleFilter">
            <el-option
              v-for="item in statusOption"
              :key="item.id"
              :label="item.mark"
              :value="item.id"
            />
          </el-select>
        </div>
        <div class="filter-box">
          <el-button
            v-waves
            class="filter-item "
            type="primary"
            :size="t('table.btnSize')"
            @click="handleFilter"
          >
            {{ t("table.search") }}
          </el-button>
          <!-- <el-button
            v-permission="{pkey:`${permissionName}_ADD`}"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('add')"
          >
            {{ t("table.add") }}
          </el-button>
          <el-button
            v-permission="{pkey:`${permissionName}_ADD`}"
            class="filter-item"
            type="primary"
            :size="t('table.btnSize')"
            @click="handleCommand('purchase')"
          >
            新建采购信息
          </el-button> -->
          <el-button
            v-waves
            class="filter-item"
            :size="t('table.btnSize')"
            @click="handleReset"
          >
            {{ t("table.reset") }}
          </el-button>
        </div>
    </div>
    <TableList
      ref="TableList"
      v-loading="listLoading"
      :dataList="list"
      :total="total"
      :page="listQuery.page"
      :size="listQuery.size"
      :columnAllData="columnAllData"
      :tableName="TableName"
      :permissionName="permissionName"
      :showSelection="true"
      :canCommand="false"
      :canChangeColumn="false"
      @command-change="handleCommand"
    >
    </TableList>
  </div>
</template>
<script lang='ts'>
import { defineComponent, reactive, toRefs, onMounted } from 'vue'
import { ElMessage } from 'element-plus'
import { cloneDeep } from 'lodash'
import { getPageList } from '@/apis/Dictionary'
import { getPageList as getUrlList } from '@/apis/Form'

import { ArrayRowsItem } from '@/model/Index'

import TableList from '@/components/common/TableList.vue'

import { TableName, permissionName } from '@/utils/enum'
import { FromFieldData } from './FieldFrom'
import { EditFormData } from './EditFieldFrom'

import { TableField } from './FieldTable'
import { defaultDate, pageVo } from '@/utils/index'

import { useI18n } from 'vue-i18n'
export default defineComponent({
  name: 'PurchaseinAdvance',
  components: {
    TableList
  },
  props: {
    excludeIds: { type: Array, required: false, default: () => [] },
    statusIn: { type: Number, required: false, default: undefined }
  },
  setup(props) {
    const { t } = useI18n()

    const dataMap = reactive({
      TableName: TableName.TABLE_PURCHASEINADVANCE,
      permissionName: permissionName.PURCHASEINADVANCE,
      initFormData: cloneDeep(FromFieldData),
      fromFieldData: cloneDeep(FromFieldData),
      EditFormData: cloneDeep(EditFormData),

      columnAllData: TableField,

      activeId: 0,
      activeRow: {},
      list: [],
      total: 0,
      listLoading: false,
      listQuery: {
        name: undefined,
        brand: undefined,
        model: undefined,
        serial: undefined,
        type: undefined,
        urgentId: undefined,
        customerCompanyName: undefined,
        customerCompanyContactName: undefined,
        customerCompanyContactPhone: undefined,
        salesManId: undefined,
        engineerId: undefined,
        outsourceCompanyName: undefined,
        outsourceCompanyContactName: undefined,
        outsourceCompanyContactPhone: undefined,
        startTime: '',
        endTime: '',
        status: (props.statusIn || props.statusIn === 0) ? props.statusIn : undefined,
        ...pageVo
      },
      dialogFormVisible: false,
      activeTab: 1,
      newHpx: 0,
      urgentOption: [],
      businessTypeOption: [],
      engineerOption: [],
      createUserOption: [],
      selectionArray: [],
      commandState: 'edit',
      selectcCustomerCompanyId: 0,
      chargeVisible: false,
      achieveType: '',
      accountOption: [],
      statusOption: [],
      async handleCommand(command: string, val?: any) {
        dataMap.commandState = command
        dataMap.activeRow = val
        switch (command) {
          case 'refresh':
            dataMap.handleFilter()
            break
          case 'column':
            break
          case 'current-change':
            dataMap.handleCurrentChange(val)
            break
          case 'size-change':
            dataMap.handleSizeChange(val)
            break
          case 'selection':
            dataMap.selectionArray = val
            break
        }
      },
      getList() {
        const { startTime, endTime } = dataMap.listQuery
        const tempsStart = startTime ? new Date(startTime).getTime() : 0
        const tempdEnd = endTime ? new Date(endTime).getTime() : 0

        if (!tempsStart) {
          return ElMessage.error({
            message: '请选择开始时间',
            duration: 1000
          })
        } else if (!tempdEnd) {
          return ElMessage.error({
            message: '请选择结束时间',
            duration: 1000
          })
        } else if (tempsStart > tempdEnd) {
          return ElMessage.error({
            message: '开始时间必须小于结束时间',
            duration: 1000
          })
        }
        dataMap.listLoading = true
        getPageList('purchaseInAdvance', {
          ...dataMap.listQuery,
          excludeIds: props.excludeIds
        }).then((res: any) => {
          dataMap.list = res.data
            ? res.data.map((item: any) => {
              const temp = item
              if (item.business) {
                Object.assign(temp, {
                  businessNo: item.business.no,
                  businessName: item.business.name,
                  businessBrand: item.business.brand,
                  businessAmount: item.business.amount,
                  businessModel: item.business.model,
                  businessSerial: item.business.serial
                })
              }

              if (item.material) {
                Object.assign(temp, {
                  materialNo: item.material.no,
                  materialClass: item.material.materialClass,
                  materialUnit: item.material.materialUnit,

                  materialId: item.material.id,

                  materialBrand: item.material.brand,
                  materialName: item.material.name,
                  materialModel: item.material.model,
                  materialCode: item.material.code,
                  materialParameter: item.material.parameter,
                  materialDevice: item.material.device
                })
              }
              return temp
            })
            : []
          dataMap.total = res.total
          dataMap.listLoading = false
          dataMap.activeId = dataMap.list.length ? dataMap.list[0].id : 0
        }).catch(() => {
          dataMap.listLoading = false
        })
      },
      handleReset() {
        dataMap.listQuery = {
          name: undefined,
          brand: undefined,
          model: undefined,
          serial: undefined,
          type: undefined,
          urgentId: undefined,
          customerCompanyName: undefined,
          customerCompanyContactName: undefined,
          customerCompanyContactPhone: undefined,
          salesManId: undefined,
          engineerId: undefined,
          outsourceCompanyName: undefined,
          outsourceCompanyContactName: undefined,
          outsourceCompanyContactPhone: undefined,
          startTime: defaultDate[0],
          endTime: defaultDate[1],
          status: undefined,
          ...pageVo
        }
        dataMap.handleFilter()
      },
      handleFilter() {
        dataMap.getList()
      },

      handleCurrentChange(page?: any) {
        dataMap.listQuery.page = page
        dataMap.getList()
      },
      handleSizeChange(size: any) {
        dataMap.listQuery.size = size
        dataMap.handleCurrentChange(1)
      },
      getDropdownList() {
        getUrlList('dropdown/PurchaseInAdvanceStatus').then((res: any) => {
          dataMap.statusOption = res || []
        })
      },
      handleCreateUserFocus() {
        getUrlList('user/dropdown/availableUses').then((res: any) => {
          dataMap.createUserOption = res || []
        })
      }
    })
    onMounted(async() => {
      dataMap.listQuery.startTime = defaultDate[0]
      dataMap.listQuery.endTime = defaultDate[1]
      dataMap.getList()
      dataMap.getDropdownList()
    })
    return { t, ...toRefs(dataMap) }
  }
})
</script>
<style  lang="scss">
.grid-layout-container {
.vue-grid-item {
  background:#666 ;
}
}
</style>
<style  lang="scss" scope>
.statusStyle{
  .status{
    // border: 1px solid;
    padding: 0 4px;
    border-radius: 6px;
    margin-right: 7px;
    font-size: 10px;
    color:#fff;
  }
}
.redStatusStyle{
  .icon-tubiao-40{
    color:#E74228;
  }
  .status{
    background-color:#E74228;
  }
}
.yellowStatusStyle{
  .icon-tubiao-40{
    color:#F3D03C;
  }
  .status{
    background-color:#F3D03C;
  }
}
.warming-fp{
  border-radius: 4px;
  border: 1px solid $red;
  color:$red;
  padding: 8px;
  margin-bottom: 20px;
}
</style>
